import { j as H } from "../../_virtual/jsx-runtime.js";
const n = ({
  width: V = 20,
  height: t = 20,
  viewBox: r = "0 0 20 20",
  fill: e = "currentColor",
  ...o
}) => /* @__PURE__ */ H.jsx(
  "svg",
  {
    width: V,
    height: t,
    viewBox: r,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...o,
    children: /* @__PURE__ */ H.jsx(
      "path",
      {
        d: "M14.1666 4.99996H18.3333V6.66663H16.6666V17.5C16.6666 17.9602 16.2935 18.3333 15.8333 18.3333H4.16663C3.70639 18.3333 3.33329 17.9602 3.33329 17.5V6.66663H1.66663V4.99996H5.83329V2.49996C5.83329 2.03973 6.20639 1.66663 6.66663 1.66663H13.3333C13.7935 1.66663 14.1666 2.03973 14.1666 2.49996V4.99996ZM15 6.66663H4.99996V16.6666H15V6.66663ZM7.49996 9.16662H9.16662V14.1666H7.49996V9.16662ZM10.8333 9.16662H12.5V14.1666H10.8333V9.16662ZM7.49996 3.33329V4.99996H12.5V3.33329H7.49996Z",
        fill: e
      }
    )
  }
);
export {
  n as default
};
